import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("auth0Store", ["auth0Initialized"]),
  },

  watch: {
    async auth0Initialized() {
      if (this.init) {
        try {
          await this.init();
        } catch (e) {
          console.error("Auth0Mixin init failed:", e);
        }
      }
    },
  },

  async created() {
    if (this.auth0Initialized && this.init) {
      try {
        await this.init();
      } catch (e) {
        console.error("Auth0Mixin init failed:", e);
      }
    }
  },
};
